import ApiRoutes from "../../../../constants/api-routes";
import { ccoInstance } from "../../../../service";

export const cooCreateNewCategory = async (body) =>
  ccoInstance.post(`${ApiRoutes.CREATE_NEW_CATEGORY}`, body);

export const cooUpdateCategory = async (categoryId, body) =>
  ccoInstance.put(`${ApiRoutes.UPDATE_CATEGORY}/${categoryId}`, body);
